import React, { Component } from "react";
import CycleFilterContextProvider from "./context/CycleFilterContext";
import DashboardContainer from "../mySCC/common/Dashboard/DashboardContainer";
import { DeviceLayoutProvider } from "../common/context/DeviceLayoutContext";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { metricReducer } from "../mySCC/common/reducers/MetricReducer";
import {
  dashboardConfigReducer,
  priorityDashboardConfigReducer,
  unsavedDashboardConfigReducer,
} from "../mySCC/common/reducers/DashboardConfigReducer";
import { isEditModeReducer } from "../mySCC/common/reducers/IsEditModeReducer";
import { availableWidgetsReducer } from "../mySCC/common/reducers/AvailableWidgetsReducer";
import { workItemAlertsReducer } from "../mySCC/common/reducers/WorkItemAlertsReducer";
import { selectedRolesReducer } from "../mySCC/common/reducers/SelectedRolesReducer";
import ToastNotificationContextProvider from "../mySCC/common/context/ToastNotificationContext";
import { FEATURES } from "../util/Constants";
import { getFeatureStatus } from "../handler/ParentDataHandler";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";

// Create the store once outside the component to prevent recreation on every render
const store = configureStore({
  reducer: {
    metricData: metricReducer,
    dashboardConfig: dashboardConfigReducer,
    unSavedDashboardConfig: unsavedDashboardConfigReducer,
    priorityDashboardConfig: priorityDashboardConfigReducer,
    isEditMode: isEditModeReducer,
    availableWidgets: availableWidgetsReducer,
    workItemAlerts: workItemAlertsReducer,
    selectedRoles: selectedRolesReducer,
  },
});

class Overviewv4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFeatureEnabled: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    getFeatureStatus(FEATURES.IS_MY_SCC_ENABLED)
      .then((isEnabled) => {
        this.setState({
          isFeatureEnabled: isEnabled.data.isMySCCEnabled,
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          isFeatureEnabled: false,
          isLoading: false,
        });
      });
  }

  render() {
    const { isFeatureEnabled, isLoading } = this.state;

    if (isLoading) {
      return <div></div>;
    }

    if (!isFeatureEnabled) {
      return (
        <Row alignmentHorizontal="center" spacingInset="xlarge">
          <Heading level={1}>Coming Soon</Heading>
        </Row>
      );
    }

    return (
      <Provider store={store}>
        <DeviceLayoutProvider>
          <CycleFilterContextProvider>
            <ToastNotificationContextProvider>
              <DashboardContainer pageSelected={"MYSCC"} />
            </ToastNotificationContextProvider>
          </CycleFilterContextProvider>
        </DeviceLayoutProvider>
      </Provider>
    );
  }
}

export default Overviewv4;



// WEBPACK FOOTER //
// ./src/components/overview/Overviewv4.js